/**
 * React hook to retrieve the query string params as an object
 */
export function useQueryString<T = Record<string, string>>() {
  return Object.fromEntries(
    new URLSearchParams(window.location.search).entries()
  ) as unknown as T
}
